import { render } from "./house-card.vue?vue&type=template&id=239ee3a0&scoped=true"
import script from "./house-card.vue?vue&type=script&lang=js"
export * from "./house-card.vue?vue&type=script&lang=js"

import "./house-card.vue?vue&type=style&index=0&id=239ee3a0&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239ee3a0"]])

export default __exports__